<template>
    <div>
        <div v-if="media">
            <ion-avatar class="big-avatar" v-if="thumbnail">
                <img :src="thumbnail">
            </ion-avatar>
            <div v-else class="media-info">
                Your video is ready for upload
            </div>
            <ion-button shape="round" v-on:click="resetMedia">{{buttonAction}} Again</ion-button>
        </div>
        <div v-else>
            <div v-if="isAndroid">
                <ion-button shape="round" v-on:click="cordovaVideo()">{{buttonText}}</ion-button>
            </div>
            <div v-else-if="isIos" class="media-recorder">
                <!-- @test - isAndroid may work on ios, this may not -->
                <!-- Doesn't allow upload -->
                <div class="record-button">
                    <input type="file" accept="video/*" class="uploader" v-on:change="onUpload($event)">
                    {{buttonText}}
                </div>
            </div>
            <div v-else class="media-recorder">
                <div class="record-button">
                    <input type="file" accept="video/*" capture class="uploader" v-on:change="onUpload($event);">
                    {{buttonText}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {device} from '@/mixins/device';
import VideoRecorder from '@/components/VideoRecorder.vue';

export default {
    name: 'video',
    created : function () {
        this.type = 'video';
    },
    props : {
        clearMedia : Function,
        setMedia : Function,
        media : {
            type : String|null,
            default : null
        },
        thumbnail : {
            type : String|null,
            default : null
        },
    },
    components: {
        VideoRecorder
    },
    mixins : [device],
    methods : {
        resetMedia : function () {
            this.clearMedia();
        },
        onUpload : function (event) {
            // console.log('video file uploaded', event);
            this.setMedia(event.target.files[0]);
        },
        cordovaVideo : function () {
            let self    = this;
            return this.$ionic.alertController.create({
                header  : 'Record a video',
                message : 'Would you like to record a video with your camera, or upload one from your gallery?',
                buttons : [
                    {
                        text : 'Camera',
                        handler : () => {
                            self.clearMedia();
                            self.recordVideo();
                        },
                    },
                    {
                        text: 'Gallery',
                        handler: () => {
                            self.clearMedia();
                            self.uploadVideo();
                        },
                    },
                ],
                })
                .then(a => a.present());
        },
        recordVideo : function () {
            navigator.device.capture.captureVideo(this.cordovaUpload, this.cordovaError, { limit : 1, quality : 0 });
        },
        uploadVideo : function () {
            let self = this;
            var options = {
                quality            : 20,
                destinationType    : Camera.DestinationType.NATIVE_URI,
                sourceType         : Camera.PictureSourceType.PHOTOLIBRARY,
                // encodingType       : Camera.EncodingType.MPEG,
                mediaType          : Camera.MediaType.VIDEO,
                allowEdit          : false,
                correctOrientation : true,
                targetHeight       : 480,
                targetWidth        : 480
            };
            // console.log('Getting phone media', options);
            navigator.camera.getPicture (
                function cameraSuccess(imageUri) {
                    // console.log('video URI is', imageUri);
                    self.fileUrlToBlob(imageUri);
                },
                function cameraError(error) {
                    console.debug("Unable to obtain video", error);
                }, options
            );
        }
    }
}
</script>
